import Divider from '@com/_atoms/Divider';
import Chips from '@com/shared/Chips';
import ViewMore from '@com/shared/view-more';

type HealthServicesProps = {
  items: string[];
};

const HealthServices = ({ items }: HealthServicesProps) => {
  return (
    <>
      <ViewMore
        title="خدمات دکتر"
        collapsedHeight={96}
        overflowThreshold={112}
        content={
          <div className="flex flex-wrap gap-x-1 gap-y-1.5">
            {items?.map((item, index) => (
              <Chips
                key={index}
                text={item}
                className="h-5 bg-surface-tertiary gap-y-0.5"
                textClassName="!text-Body/xSmall text-content-primary"
              />
            ))}
          </div>
        }
      />

      <Divider padding={0} className="h-2 bg-surface-secondary mb-4" />
    </>
  );
};

export default HealthServices;
